/* eslint-disable */
<template>
  <div>
    <div class="container-fluid w-100 no-padding">
      <div class="row bg-primary-dark">
        <div class="col-md-4 mb-2 mt-2 align-middle">
          <h4>Çevrimdışı Cihaz Notları</h4>
        </div>
        <div class="col-md-4 mb-2 mt-2 align-middle">
          <select class="form-control" v-model="selectedRetailerId" @change="getDevices()">
            <option value="1">LENOI</option>
            <option value="5">BÜLENT EŞKİ</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <v-wait for="devices-loading">
            <template slot="waiting">
              <div class="vue-wait-class">
                <img src="static/loading.svg" />
                <p>Veriler yükleniyor...</p>
              </div>
            </template>
            <table class="table table-bordered table-striped table-hover">
              <thead class="thead-light">
                <tr>
                  <th style="width: 32px;" scope="col">#</th>
                  <th style="width: 20%;" scope="col">MÜŞTERİ / ARAÇ</th>
                  <th style="width: 10%;" scope="col">SON VERİ</th>
                  <th style="width: 20%;" scope="col">SON DURUM</th>
                  <th style="width: auto;" scope="col">NOT</th>
                  <th style="width: 10%;" scope="col">NOT TARİHİ</th>
                  <th style="width: 16%;" scope="col">KOMUTLAR</th>
                </tr>
              </thead>
              <tbody class="tbody-margin">
                <template v-for="(device, deviceIndex) in devices">
                  <tr :key="'trow-first-' + deviceIndex">
                    <td class="align-middle text-left">{{deviceIndex + 1}}</td>
                    <td class="align-middle text-left">
                      <div class="justify-content-between">
                        <p class="my-0 text-primary font-semi-bold">{{ device.CUSTOMER_TITLE }}</p>
                        <p class="my-0 tabular-nums"><b>{{ device.VEHICLE_NAME ? device.VEHICLE_NAME + ' &bull;' : '' }}</b> {{device.IMEI_NO}}</p>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <div class="justify-content-between">
                        <p class="my-0 font-semi-bold">{{ parseServerTime(device.SERVER_TIME)  }}</p>
                        <small class="text-muted tabular-nums">{{ formatServerTime(device.SERVER_TIME) }}</small>
                      </div>
                    </td>
                    <td class="align-middle text-center">{{ parseStatus(device) }}</td>
                    <td class="align-middle text-center">{{device.NOTE}}</td>
                    <td class="align-middle text-center">{{formatDate(device)}}</td>
                    <td class="align-middle">
                      <button class="btn btn-sm btn-more-radius btn-primary" data-toggle="modal"
                        data-target="#noteUpsertModal" @click="openModal(deviceIndex, 0)">Not Ekle</button>
                      <button class="btn btn-sm btn-more-radius btn-danger" data-toggle="modal"
                        data-target="#noteUpsertModal" @click="openModal(deviceIndex, 1)">Notu Temizle</button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </v-wait>
        </div>
      </div>
    </div>
    <div class="modal fade bd-example-modal-lg" id="noteUpsertModal" tabindex="-1"
      role="dialog" aria-labelledby="uetdsModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="uetdsModalLabel">Not Ekle/Güncelle</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="note-upserting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Not Kaydediliyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="customerTitle">MÜŞTERİ</label>
                    <input disabled type="text" class="form-control" v-model="selectedDevice.CUSTOMER_TITLE" id="customerTitle">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="device-vehicle">ARAÇ</label>
                    <input disabled type="text" class="form-control" v-model="selectedDevice.VEHICLE_NAME" id="device-vehicle">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="device-imei">CİHAZ SERİ NO</label>
                    <input disabled type="text" class="form-control" v-model="selectedDevice.IMEI_NO" id="device-imei">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="device-note">NOT</label>
                    <textarea rows="5" :disabled="modalMode == 1" type="text" class="form-control" v-model="selectedDevice.NOTE" id="device-note"></textarea>
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="upsertNote()" class="btn btn-success">{{ modalMode ? 'Notu Temizle' : 'Not Ekle/Güncelle'}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'DisconnectedDevicesPage',
  components: {
    Datepicker
  },
  data () {
    return {
      messageText: '',
      devices: [],
      modalMode: 0,
      selectedDevice: {},
      selectedRetailerId: 1
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
  },
  methods: {
    parseStatus(device) {
      let statusComments = []

      if(device.ONBATTERY == 1)
        statusComments.push('Akü bağlantısı kesik')

      if(device.SATELITE < 2)
        statusComments.push('GPS bağlantısı kesik')

      if(device.ENGINE == 1) {
        if(device.SPEED > 0)
          statusComments.push('Kontak açık, hareketli')
        else if(device.SPEED == 0 || device.SPEED == null)
          statusComments.push('Rölantide')
      } else {
        if(device.SPEED > 0) {
          statusComments.push('Kontak kapalı, hareketli (bu sebeple kontak bağlantısı problemli olabilir)')
        }
        else
          statusComments.push('Kontak kapalı, durağan halde')
      }
      
      if(statusComments.length == 0) {
        console.log(device.IMEI_NO + ' - ' + device.ONBATTERY + ' - ' + device.SATELITE + ' - ' + device.SPEED + ' - ' + device.ENGINE)
        statusComments.push('Belirgin sebebi olmayan bağlantı kesilmesi')
      }

      return statusComments.join(', ')
    },
    parseServerTime(serverTime) {
      return moment(serverTime).fromNow()
    },
    formatServerTime(serverTime) {
      return moment(serverTime).format('DD.MM.YYYY HH:mm')
    },
    formatDate(device) {
      if(!device.NOTE || device.NOTE == '')
        return '-'

      if(device.MODIFIED_AT)
        return moment(device.MODIFIED_AT).format('DD.MM.YYYY HH:mm')
      else if(device.CREATED_AT)
        return moment(device.CREATED_AT).format('DD.MM.YYYY HH:mm')
      
      return '-'
    },
    getDevices() {
      this.$wait.start('devices-loading');

      axios
      .get('/api/devices/disconnected-devices/' + this.selectedRetailerId)
      .then(response => {
        this.devices = response.data
        this.$wait.end('devices-loading')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('devices-loading')
      })
    },
    upsertNote() {
      this.$wait.start('note-upserting');
      axios
      .put(
        '/api/devices/' + this.selectedDevice.DEVICE_ID + '/upsert-note', 
        { note: this.modalMode == 0 ? this.selectedDevice.NOTE : '' }
      )
      .then(response => {
        this.getDevices()
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('note-upserting')
      })
      .finally(() => {
        this.$wait.end('note-upserting')
        this.selectedDevice = {}
        $('#noteUpsertModal').modal('hide')
      })
    },
    openModal(index, mode) {
      this.selectedDevice = this.devices[index]
      this.modalMode = mode

      console.log(this.selectedDevice)
      console.log(this.modalMode)

      $("#noteUpsertModal").modal({
        backdrop: 'static',
        keyboard: false
      })
    }
  },
  beforeMount() {
    moment.locale('tr')
  },
  mounted() {
    this.getDevices()
  }
}
</script>

<style scoped>
  .font-semi-bold {
    font-weight: 700 !important;
  }

  .tabular-nums {
    -moz-font-feature-settings: "tnum";
    -webkit-font-feature-settings: "tnum";
    font-feature-settings: "tnum";
    font-variant-numeric: tabular-nums;
    letter-spacing: 0.025em;
  }

  div.icon-global {
    position: absolute;
    z-index: 3;
    margin-left: -36px;
    margin-top: 24px;
    width: 30px;
    height: 30px;
    padding: 4px 4px 5px 4px;
    border-radius: 15px;
  }

  div.icon-global.bg-danger {
    margin-top: -6px !important;
  }

  div.icon-global i {
    color: #FFF;
  }

  .margin-negative {
    margin-bottom: -4px !important;
  }

  input.btn-more-radius {
    text-indent: 10px;
  }

  .table-row {
    display: block;
    width: 100%;
  }
  
  table { caption-side: top !important; }
  table, .dropdown-item {
    font-size: .875rem;
  }

  td .btn {
    font-size: 0.875rem;
  }

  td a.btn {
    font-size: .875rem;
  }

  .btn i {
    color: #FFF;
  }

  .btn:hover i {
    color: #FFF !important;
  }

  tr.collapsed-row {
    background: #F0F0F0;
    /*-webkit-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    -moz-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);*/
  }

  span.badge {
    font-size: 100%;
    font-weight: 400;
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  .no-padding {
    padding: 0;
    margin: 0;
  }

  .no-padding .row {
    margin: 0;
  }

  .no-padding .row .col-md-12, .no-padding .row .col-md-9, .no-padding .row .col-md-3 {
    margin: 0 !important;
    padding: 0 !important;
  }

  .caption {
    font-size: 15px;
    font-weight: 700;
    color: #e9ecef;
    background-color: #010929;
    vertical-align: center;
    padding: 11px 15px 12px 15px;
  }
  
  .conversation-view {
    display: block;
    position: absolute;
    z-index: 2;
    width: 350px;
    height: 70%;
    left: 3%;
    bottom: 4.5%;
    border: 1px solid #dee2e6;

    -webkit-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    -moz-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    box-shadow: 0px 10px 30px -4px rgba(200,200,200,1); 
  }

  .bubble span {
    display: inline-block;
    min-width: 120px !important;
    width: auto;
    max-width: 70%;
    padding: 6px 20px;
    color: #fff;
    background-color: #007bff;
    border-radius: 30px;
  }

  .bubble small {
    display: block;
    width: 100%;
    margin-left: 8px;
    font-size: 75%;
  }

  .bubble.own span {
    background-color: #e83e8c;
  }

  .bubble.own small {
    margin-right: 8px;
  }

  .modal-body-fixed {
    height: 300px;
    max-height: 300px !important;
    overflow: auto;
  }

  .overflow-y {
    min-height: 100%;
    overflow: auto !important;
  }

  .text-truncated {
    display: block !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

</style>


// WEBPACK FOOTER //
// src/components/DisconnectedDevicesPage.vue